import React from "react";
import PropTypes from "prop-types";

import IconCopy from "components/Icon/Copy";
import FeatureRenderer from "components/Feature/RendererContainer";
import { TRow, ActionCell } from "./WorkList.styles";

const formatDate = x =>
  new Date(x).toLocaleDateString("en-us", {
    year: "numeric",
    month: "numeric",
    day: "numeric"
  });

const formatTZDate = x => new Date(Date.parse(x + " UTC")).toLocaleString();

const renderCell = ({ id, active, item, onClone }, key) => {
  if (!active) {
    return null;
  }

  switch (id) {
    case "Claim #":
      return <td key={id} id={key}>{item.claimNumber}</td>;
    case "Insured Name":
      return <td key={id} id={key} dangerouslySetInnerHTML={{__html:item.insuredName}}/>;
    case "Vehicle":
      return <td key={id} id={key}>{item.vehicle}</td>;
    case "State":
      return <td key={id} id={key}>{item.state.toUpperCase()}</td>;
    case "Loss Date":
      return <td key={id} id={key}>{formatDate(item.dateOfLoss)}</td>;
    case "Creation Date":
      return <td key={id} id={key}>{formatTZDate(item.creationDate)}</td>;
    case "Status":
      return <td key={id} id={key}>{item.status}</td>;
    case "Actions":
      return (
        <FeatureRenderer feature="FeesActions" key={id}>
          <ActionCell>
            {/*
            <IconEmail title="Email" />
            <IconPDF title="Download PDF" />
            */}
            <IconCopy title="Clone Work Item"  id={key} onClick={(event) => {onClone(item.id); event.stopPropagation();}} />
          </ActionCell>
        </FeatureRenderer>
      );
    default:
      return <td />;
  }
};

const WorkItem = ({ item, onClick, onClone, columnConfig, row}) => {
  return (
    <TRow onClick={() => onClick(item.id)} >
      {columnConfig.map(({ id, active}, index) => renderCell({ id, active, item, onClone},`${row}_${index}`))}
    </TRow>
  );
};

WorkItem.propTypes = {
  item: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  onClone: PropTypes.func,
  columnConfig: PropTypes.array.isRequired
};

WorkItem.defaultProps = {
  onClick: () => {},
  onClone: () => {}
};

export default WorkItem;
